import { render, staticRenderFns } from "./AddonUpsell.vue?vue&type=template&id=56d46cc7"
import script from "./AddonUpsell.vue?vue&type=script&lang=ts"
export * from "./AddonUpsell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports